// extracted by mini-css-extract-plugin
export default {"YoutubeEmbed":"bbp_a"};